import React from 'react'
import { useTranslation } from 'react-i18next'

const PermisoDenegado = () => {
  const { t } = useTranslation();

  return (
    <main className='ticket-denegado site-width'>
      <div className="acceso-denegado">
        <img src="/images/boton-eliminar.svg" alt={t('estados.accesoDenegado')} />
        <h2>{t('estados.accesoDenegado')}</h2>
        <p>{t('estados.accesoDenegadoTexto')}</p>
      </div>
    </main>
  )
}

export default PermisoDenegado
